export type UploadedBatchScopeObservation = {
  selectAll: boolean;
  selectedClipCount: number;
  sessionId: string | null;
};

/**
 * Whether the uploaded-batch attachment should drop.
 * An empty selection does not count: the offer click clears the selection right after attaching.
 * A session id of null does not count: `startNewThread` resets to null and the offer rides that reset.
 * The first observation is a baseline, so a selection that is already empty or already present does not clear.
 */
export const shouldClearUploadedBatchAttachment = (
  previous: UploadedBatchScopeObservation | null,
  next: UploadedBatchScopeObservation,
): boolean => {
  if (!previous) {
    return false;
  }

  const hadWorkspaceSelection = previous.selectedClipCount > 0 || previous.selectAll;
  const hasWorkspaceSelection = next.selectedClipCount > 0 || next.selectAll;

  if (hasWorkspaceSelection && !hadWorkspaceSelection) {
    return true;
  }

  return next.sessionId !== null && next.sessionId !== previous.sessionId;
};
